module.exports = __webpack_public_path__ + "02_medium_brown.be92fc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_medium_brown.png
// module id = 67rN
// module chunks = 0